'use strict';

Object.defineProperty(exports, '__esModule', {
        value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _App = require('./App');

var _App2 = _interopRequireDefault(_App);

var _Home = require('./Home');

var _Home2 = _interopRequireDefault(_Home);

var _vrPlayerPlayer = require('./vr-player/Player');

var _vrPlayerPlayer2 = _interopRequireDefault(_vrPlayerPlayer);

var _vrPlayerPlayerDemo = require('./vr-player/PlayerDemo');

var _vrPlayerPlayerDemo2 = _interopRequireDefault(_vrPlayerPlayerDemo);

var _ = require('./404');

var _2 = _interopRequireDefault(_);

exports['default'] = _react2['default'].createElement(
        _reactRouter.Route,
        { path: '/', component: _App2['default'] },
        _react2['default'].createElement(_reactRouter.IndexRoute, { component: _Home2['default'] }),
        _react2['default'].createElement(_reactRouter.Route, { path: 'react-vr-player', component: _vrPlayerPlayer2['default'] }),
        _react2['default'].createElement(_reactRouter.Route, { path: 'react-vr-player-demo', component: _vrPlayerPlayerDemo2['default'] }),
        _react2['default'].createElement(_reactRouter.Route, { path: '*', component: _2['default'] })
);
module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ./~/babel-loader!./source/routes.jsx
 **/